export var BorderRadiusSize = {
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg'
};